const addBackToDashboard = require('./src/addBackToDashboard');
const addPopupModal = require('./src/addPopupModal');
const addStyle = require('./src/addStyle');
const addScript = require('./src/addScript');
const validateUser = require('./src/validateUser');
const {
  showUpgradeModal,
  showMaxTokenUpgradeModal,
  showMaxTokenEntUpgradeModal,
  showMaxCreditUpgradeModal,
  showMonthlyLimitModal,
  showMonthlyLimitEntModal
} = require('./src/showPopup')
const {
  removeImageFlux,
  clearImageFlux
} = require('./src/removeImageFlux');

module.exports = {
  addBackToDashboard,
  addPopupModal,
  addStyle,
  addScript,
  removeImageFlux,
  clearImageFlux,
  showUpgradeModal,
  showMaxTokenUpgradeModal,
  showMaxTokenEntUpgradeModal,
  showMaxCreditUpgradeModal,
  validateUser,
  showMonthlyLimitModal,
  showMonthlyLimitEntModal
};